import React, { Component } from 'react';
import LinkTab from '../../../../common/tab/TabNav.js';
import { tabs } from '../VacationUtil';
import MainTable from '../../../../common/table/MainTable';
import NewAvailableVacation from './NewAvailableVacation';
import * as columns from './AvailableVacationColumns';

class AvailableVacation extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "AVAILABLE_VACATION";
            return item;
        })
        return data;
    }

    render() {
        return (
            <>
                <LinkTab tabs={tabs} index={0} />
                <MainTable
                    divClassName="availablevacation"
                    tableName="Éves szabadságok"
                    newObjectLabel="Új éves szabadság hozzáadása"
                    path='/api/availablevacations'
                    enrich={this.enrich}
                    columns={(props) => columns.columns(props)}
                    dialogContent={(refresh, close) => <NewAvailableVacation refresh={refresh} close={close} />} />
            </>
        );
    }
}

export default AvailableVacation;